export default __webpack_public_path__ + "static/media/icon2.0ebea157.png";